export default __webpack_public_path__ + "static/media/smartBridge.661ab91c.png";